import React, { useState, useEffect } from 'react'
// routing
import Routes from 'routes'

// project imports
import Locales from 'ui-component/Locales'
import NavigationScroll from 'layout/NavigationScroll'
import RTLLayout from 'ui-component/RTLLayout'
import Snackbar from 'ui-component/extended/Snackbar'
import ThemeCustomization from 'themes'
// import store from "./store/index"
import { loadUser } from './store/slices/userLoginAction'
import { getLabelsName ,getLabelVersion} from './store/slices/labelAction'
import { store, persister } from 'store'
import { PersistGate } from 'redux-persist/integration/react'


// ==============================|| APP ||============================== //

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser())
    store.dispatch(getLabelVersion(1))
  }, [])

  return (
    <ThemeCustomization store={store}>
      <PersistGate loading={null} persistor={persister}>
        <RTLLayout>
          <Locales>
            <NavigationScroll>
              <>
                <Routes />
                <Snackbar />
              </>
            </NavigationScroll>
          </Locales>
        </RTLLayout>
      </PersistGate>
    </ThemeCustomization>
  )
}

export default App
